import { Component, Prop, h } from '@stencil/core'
import {
  BUTTONS_TYPES,
  getElementType,
  HTML_TAGS,
  ICONS,
  LINK_RELATIONSHIPS,
  LINK_TARGETS,
  BUTTONS_SIZES_TYPES,
  ICONS_SIZES_TYPES,
  ICONS_SIZES_KINDS,
  ICON_TYPES,
} from '../../utils'

@Component({
  tag: 'snap-icon',
  styleUrl: 'snap-icon.scss',
})
export class SnapIcon {
  /**
   * Render as will overide the default and logic driven html wrapper of this component. Use with care.
   */
  @Prop() as: HTML_TAGS
  /**
   * Does this element need an href
   */
  @Prop() href: string
  /**
   * Does if this is an href, does it need a special target. default is '_self'
   */
  @Prop() target: LINK_TARGETS
  /**
   * Does if this is an href, does it need a special relationship label
   */
  @Prop() rel: LINK_RELATIONSHIPS
  /**
   * Label for the link. Aria labels describe the purpose of a link in HTML
   */
  @Prop() label: string
  /**
   * If this is to be a button, what type should it be
   */
  @Prop() buttonType: BUTTONS_TYPES
  /**
   * If this is to be a button, is it disabled
   */
  @Prop() disabled: boolean
  /**
   * If this is to be a button, The name of the button, submitted as a pair with the button’s value as part of the form data, when that button is used to submit the form.
   */
  @Prop() name: string
  /**
   * Only valid for input types (submit, reset).
   */
  @Prop() value: string
  /**
   * Pick an icon from our library
   */
  @Prop({ reflect: true }) icon: ICON_TYPES

  /**
   * Does the icon get a circle background
   */
  @Prop() circle: boolean = false
  /**
   * Circle size. For now we just have default or small
   */
  @Prop() circleSize: BUTTONS_SIZES_TYPES

  @Prop({ reflect: true }) color: string
  @Prop({ reflect: true }) size: ICONS_SIZES_TYPES = 'md'
  @Prop({ reflect: true }) state: 'default' | 'rounded' | 'square' = 'default'
  @Prop({ reflect: true }) bgColor = '#FFF'
  @Prop({ reflect: true }) indicator: string | boolean = false

  getClasses() {
    const classes = ['snap-icon']
    if (this.state === 'rounded') {
      classes.push('snap-icon--rounded')
      classes.push(`snap-icon--rounded--${this.size}`)
    } else if (this.state === 'square') {
      classes.push('snap-icon--square')
      classes.push(`snap-icon--square--${this.size}`)
    }
    return classes.join(' ').toString()
  }

  render() {
    const ElementType = getElementType(this, 'span')

    if (this.icon) {
      return (
        <ElementType
          innerHTML={ICONS[this.icon]}
          class={this.getClasses()}
          type={this.buttonType}
          value={this.buttonType === 'submit' ? this.value : null}
          href={this.href ? this.href : null}
          target={this.href ? this.target : null}
          disabled={this.disabled}
          style={{
            color: this.color,
            width: this.state == 'default' ? ICONS_SIZES_KINDS[this.size] : '',
            height: this.state == 'default' ? ICONS_SIZES_KINDS[this.size] : '',
            backgroundColor: this.state === 'rounded' || this.state === 'square' ? this.bgColor : 'inherit',
            borderColor: this.state === 'rounded' || this.state === 'square' ? this.bgColor : 'initial',
          }}>
          {this.indicator && <snap-indicator size="tiny" color="gray" text={this.indicator as string}></snap-indicator>}
        </ElementType>
      )
    } else {
      return (
        <ElementType
          class={this.getClasses()}
          type={this.buttonType}
          value={this.buttonType === 'submit' ? this.value : null}
          href={this.href ? this.href : null}
          target={this.href ? this.target : null}
          disabled={this.disabled}
          style={{
            color: this.color,
            width: ICONS_SIZES_KINDS[this.size],
            height: ICONS_SIZES_KINDS[this.size],
            backgroundColor: this.state === 'rounded' || this.state === 'square' ? this.bgColor : 'inherit',
          }}>
          <slot />
        </ElementType>
      )
    }
  }
}
